/** Fields for puzzle_loaded after a successful restore (spec §5). */
export function puzzleLoadedRestoredPayload(puzzleDate, gridSize, isHardMode, isSolved, completedToday) {
  return {
    grid_size: gridSize,
    puzzle_date: puzzleDate,
    mode: isHardMode ? 'hard' : 'normal',
    restored: isSolved && completedToday ? 2 : 1,
  };
}
